import {
  // GET APP NAVIGATION
  GET_APP_NAVIGATION_REQUEST,
  GET_APP_NAVIGATION_SUCCESS,
  GET_APP_NAVIGATION_FAILURE,
  // LOGOUT
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  // GET USER INFO
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_REQUEST,

  //PROFILE INFO
  SAVE_PROFILE_REQUEST,
  SAVE_PROFILE_SUCCESS,
  SAVE_PROFILE_FAILURE

} from "../Constants";

const initialAuthState = {
  isFetching: false,
  isAuthenticated: false,
  ssoId: null
};

export default (state = initialAuthState, action) => {
  switch (action.type) {
    case GET_APP_NAVIGATION_REQUEST:
      return {
        ...state,
        isFetching: action.isFetching
      };
    case GET_APP_NAVIGATION_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        isAuthenticated: action.isAuthenticated,
        ssoId: action.ssoId,
        appData: action.appData
      };
    case GET_APP_NAVIGATION_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
        isAuthenticated: action.isAuthenticated,
        errorMessage: action.errorMessage
      };

    case LOGOUT_REQUEST:
      return {
        ...state,
        isFetching: action.isFetching
      };

    case LOGOUT_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
        errorMessage: action.errorMessage
      };

    case LOGOUT_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        isAuthenticated: action.isAuthenticated,
        ssoId: action.ssoId,
        user: {}
      };

    case GET_USER_REQUEST:
      return {
        ...state,
        isFetching: action.isFetching
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        user: action.user
      };
    case GET_USER_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
        errorMessage: action.errorMessage
      };

    case SAVE_PROFILE_REQUEST:
      return {
        ...state,
        isFetching: action.isFetching
      };
    case SAVE_PROFILE_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        message: action.message
      };
    case SAVE_PROFILE_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};
